import { Form, InputNumber, Row, Col } from 'antd';
import i18next from 'i18next';

interface InputTauxDoubleProps {
  label?: string;
  name: [string, string];
  width?: number;
  widthl?: number;
  placeholder?: string;
  notRequired?: boolean;
  disabled?: boolean;
  icon?: any;
  min?: number;
  max?: any;
  autoFocus?: boolean;
  dependencies?: string[];
  RegExp?: RegExp;
  MessExp?: string;
  rules?: any[];
  mode?: 'exclusif' | 'obligatoire';
  required?: boolean;
}

const InputTauxDouble = ({
  notRequired,
  RegExp: customRegExp,
  MessExp: customMessExp,
  rules = [],
  width,
  widthl,
  label,
  name,
  dependencies,
  autoFocus,
  disabled,
  placeholder,
  max,
  min,
  icon,
  mode = 'exclusif',
  required = false,
}: InputTauxDoubleProps) => {
  const form = Form.useFormInstance();
  const isRequired = !notRequired || required;
  const [namePourcent, nameMoney] = name;

  const handlePourcentChange = (val: number | null) => {
    if (mode === 'exclusif') {
      // Si la valeur est 0 ou null ou undefined, on considère que c'est vide
      if (val === null || val === undefined || val === 0) {
        // Ne rien faire, le champ est vide
      } else {
        // Sinon, on vide l'autre champ
        form.setFieldValue(nameMoney, undefined);
      }
    }
    setTimeout(() => {
      form.validateFields([namePourcent, nameMoney]);
    }, 0);
  };

  const handleMoneyChange = (val: number | null) => {
    if (mode === 'exclusif') {
      if (val === null || val === undefined || val === 0) {
        // Ne rien faire, le champ est vide
      } else {
        form.setFieldValue(namePourcent, undefined);
      }
    }
    setTimeout(() => {
      form.validateFields([namePourcent, nameMoney]);
    }, 0);
  };

  return (
    <Form.Item
      noStyle
      shouldUpdate={(prevValues, currentValues) =>
        prevValues[namePourcent] !== currentValues[namePourcent] ||
        prevValues[nameMoney] !== currentValues[nameMoney]
      }
    >
      {() => {
        const valPourcent = form?.getFieldValue(namePourcent);
        const valMoney = form?.getFieldValue(nameMoney);

        // CONSIDÉRER QUE 0 EST UNE VALEUR VIDE
        const hasPourcentValue = valPourcent !== undefined && 
                                valPourcent !== null && 
                                valPourcent !== '' && 
                                valPourcent !== 0 &&
                                !isNaN(Number(valPourcent));

        const hasMoneyValue = valMoney !== undefined && 
                             valMoney !== null && 
                             valMoney !== '' && 
                             valMoney !== 0 &&
                             !isNaN(Number(valMoney));

        // Pour l'affichage, on garde 0 mais on le considère comme vide
        const isGlobalRequired = mode === 'obligatoire' 
          ? isRequired 
          : isRequired && !hasPourcentValue && !hasMoneyValue;

        // Désactiver seulement si l'autre champ a une valeur > 0
        const isPourcentDisabled = disabled || 
          (mode === 'exclusif' && hasMoneyValue);

        const isMoneyDisabled = disabled || 
          (mode === 'exclusif' && hasPourcentValue);

        const pourcentRules = [
          { 
            required: mode === 'obligatoire' ? isRequired : isRequired && !hasMoneyValue, 
            message: 'Le taux ou le montant est requis' 
          },
          { pattern: /^(100|[1-9]?\d)$/, message: 'pas plus de 100 %' },
          ...rules,
        ];

        const moneyRules = [
          { 
            required: mode === 'obligatoire' ? isRequired : isRequired && !hasPourcentValue, 
            message: 'Le taux ou le montant est requis' 
          },
          ...(customRegExp ? [{ pattern: customRegExp, message: customMessExp || '' }] : []),
          ...rules,
        ];

        return (
          <Form.Item
            labelCol={{ span: width || 8, offset: widthl || 0 }}
            label={label}
            className="bordure"
            dependencies={dependencies}
            required={isGlobalRequired}
          >
            <Row gutter={8}>
              <Col span={12}>
                <Form.Item name={namePourcent} rules={pourcentRules} noStyle>
                  <InputNumber
                    min={0}
                    max={100}
                    formatter={(val) => {
                      if (val === undefined || val === null) return '';
                      return `${val}%`;
                    }}
                    parser={(val: string | undefined) => {
                      if (!val || val === '') return undefined as any;
                      const clean = val.replace('%', '').trim();
                      if (clean === '') return undefined as any;
                      const parsed = Number(clean);
                      return isNaN(parsed) ? undefined as any : parsed;
                    }}
                    style={{ width: '100%' }}
                    disabled={isPourcentDisabled}
                    placeholder={placeholder || 'Taux %'}
                    onChange={handlePourcentChange}
                  />
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item name={nameMoney} rules={moneyRules} noStyle>
                  <InputNumber
                    autoFocus={autoFocus}
                    formatter={(val) => {
                      if (val === undefined || val === null) return '';
                      return `${val}`.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
                    }}
                    parser={(val: string | undefined) => {
                      if (!val || val === '') return undefined as any;
                      const clean = val.replace(/\$\s?|( *)/g, '');
                      if (clean === '') return undefined as any;
                      const parsed = Number(clean);
                      return isNaN(parsed) ? undefined as any : parsed;
                    }}
                    max={max}
                    step="1"
                    lang={i18next.language}
                    min={min !== undefined ? Math.max(0, min) : 0}
                    style={{ width: '100%' }}
                    disabled={isMoneyDisabled}
                    addonBefore={icon}
                    placeholder={placeholder || 'Montant Fixe'}
                    onChange={handleMoneyChange}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form.Item>
        );
      }}
    </Form.Item>
  );
};

export default InputTauxDouble;